import { GridRowClassNameParams, GridRowId, GridRowSelectionModel } from '@mui/x-data-grid-premium'
import dayjs from 'dayjs'

// Helper to determine if a task is postdated (matches column valueGetter logic)
const isTaskPostdated = (row: any): boolean => {
  if (row?.isPostdated !== undefined) return row.isPostdated
  if (!row?.startDate) return false
  const startDate = dayjs(row.startDate)
  return startDate.isAfter(dayjs(), 'day')
}

export const getTeamTaskClassNames = (
  params: GridRowClassNameParams,
  rowSelectionModel: GridRowSelectionModel,
  allRowIds: GridRowId[]
) => {
  const disabledRowIds = new Set()
  if (Array.from(rowSelectionModel.ids).length > 0) {
    const selectedInfo = Array.from(rowSelectionModel.ids).map(id => {
      const [PK, SK] = (id as string).split('::')
      const isParentTask = !!SK && SK.startsWith('TASK_')
      const isSubtask = !!SK && SK.startsWith('SUBTASK_')
      return { id, PK, SK, isParentTask, isSubtask }
    })
    const hasParentSelected = selectedInfo.some(s => s.isParentTask)
    const hasChildSelected = selectedInfo.some(s => s.isSubtask)
    if (hasParentSelected) {
      const childRowIds = allRowIds.filter(id => (id as string)?.includes('SUBTASK_'))
      childRowIds.forEach(id => disabledRowIds.add(String(id)))
    }
    if (hasChildSelected) {
      const parentRowIds = allRowIds.filter(id => !(id as string)?.includes('SUBTASK_'))
      parentRowIds.forEach(id => disabledRowIds.add(String(id)))
    }
  }

  const classNames: string[] = []
  if (params.row.isCreative) classNames.push('creative-row-border')
  if (params.row.isMarketing) classNames.push('marketing-row-border')
  if (params.row.isWebsite) classNames.push('website-row-border')
  if (!params.row.isMarketing && !params?.row?.isCreative) classNames.push('website-row-border')
  if (params.row.highPrio) classNames.push('high-priority-row')
  if (params.row.isSubtask) classNames.push('subtask-row')
  if (isTaskPostdated(params.row)) classNames.push('postdated')
  if (disabledRowIds.has(params.id)) classNames.push('disabled-selection')
  return classNames.join(' ')
}
